import './UserProfileHeader.css'

export default function UserProfileHeader() {
   return (
      <header className='UserProfile-header-container'>
         <h2 className='UserProfile-header-text'>Editar perfil</h2>
      </header>
   )
}
